// extracted by mini-css-extract-plugin
export default {"loading":"bXU8svnN9hkR5cZWmCOJ","loadingContent":"nVOnkAn6X4wI3Cj7JOXP"};